import { DateInput, DateRangeInput } from 'components/inputs'
import NumberSelect from 'components/v2/NumberSelect'
import ClientSelect from 'core/client/components/ClientSelect'
import { CompanySelect } from 'core/company'
import ExpenseTypeSelect from 'core/expenseType/components/ExpenseTypeSelect'
import LocationSelect from 'core/location/components/LocationSelect'
import PaymentEntryTypeSelect from 'core/paymentEntry/components/PaymentEntryTypeSelect'
import PaymentTypeSelect from 'core/paymentType/components/PaymentTypeSelect'
import ProductSelect from 'core/product/components/v2/ProductSelect'
import TicketTypeSelect from 'core/ticketType/components/TicketTypeSelect'
import UserSelect from 'core/user/components/UserSelect'
import SubscriptionMacSearch from 'core/subscription/components/SubscriptionMacSearch';
import React, { useState, useEffect } from 'react' // Importar useState y useEffect
import { Form } from 'semantic-ui-react'
import TicketTypeSelectMulti from 'core/ticketType/components/TicketTypeSelectMulti'
import EmployeeSelect from 'core/employee/components/EmployeeSelect'

export default function Filters(props) {
  const {
    date,
    dateRange,
    company,
    client,
    location,
    paymentType,
    paymentEntryType,
    expenseType,
    ticketType,
    product,
    user,
    creator,
    numRows,
    setNumRows,
    wanMac,
    filters,
    setFilters,
    employee,
    code
  } = props
  const {
    companyId,
    clientId,
    userId,
    createdBy,
    locationId,
    paymentTypeId,
    type,
    expenseTypeId,
    ticketTypeId,
    productId,
    subscriptions,
    code: filterCode
  } = filters || {}

  // Estado local para el valor temporal del código
  const [localCode, setLocalCode] = useState(filterCode || '')

  // Sincronizar el estado local cuando cambia el filtro externo
  useEffect(() => {
    setLocalCode(filterCode || '')
  }, [filterCode])

  // Manejar la tecla Enter
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setFilters(filters => ({ ...filters, code: localCode }))
    }
  }

  return (
    <Form id='amber-filters'>
      <Form.Group widths='equal'>
        {date && (
          <DateInput
            value={filters.date}
            onChange={date => setFilters(filters => ({ ...filters, date }))}
          />
        )}

        {dateRange && (
          <DateRangeInput
            from={filters.fromDate}
            to={filters.toDate}
            onFromChange={fromDate =>
              setFilters(filters => ({ ...filters, fromDate }))
            }
            onToChange={toDate =>
              setFilters(filters => ({ ...filters, toDate }))
            }
          />
        )}

        {code && (
          <Form.Input
            label='Código'
            placeholder='Buscar por código'
            value={localCode}
            onChange={(e, { value }) => setLocalCode(value)}
            onKeyPress={handleKeyPress}
          />
        )}

        {company && (
          <CompanySelect
            loadOnMount={false}
            value={companyId}
            onChange={companyId =>
              setFilters(filters => ({ ...filters, companyId }))
            }
          />
        )}

        {client && (
          <ClientSelect
            loadOnMount={false}
            value={clientId}
            clientType={typeof client === 'string' ? client : null}
            onChange={clientId => setFilters(filters => ({ ...filters, clientId }))}
          />
        )}

        {user && (
          <UserSelect
            loadOnMount={false}
            value={userId}
            onChange={userId => setFilters(filters => ({ ...filters, userId }))}
          />
        )}

        {creator && (
          <UserSelect
            loadOnMount={false}
            value={createdBy}
            onChange={createdBy => setFilters(filters => ({ ...filters, createdBy }))}
            label="Creado Por"
          />
        )}

        {employee && (
          <Form.Field>
            <EmployeeSelect
              value={filters.employeeId}
              onChange={(value) => setFilters({
                ...filters,
                employeeId: value,
                employeeName: ''
              })}
              excludeInactive={false}
              clearable
              placeholder="Seleccione un empleado"
            />
          </Form.Field>
        )}

        {location && (
          <LocationSelect
            loadOnMount={false}
            value={locationId}
            onChange={locationId =>
              setFilters(filters => ({ ...filters, locationId }))
            }
          />
        )}

        {paymentType && (
          <PaymentTypeSelect
            loadOnMount={false}
            value={paymentTypeId}
            onChange={paymentTypeId =>
              setFilters(filters => ({ ...filters, paymentTypeId }))
            }
          />
        )}

        {paymentEntryType && (
          <PaymentEntryTypeSelect
            multiple
            value={type}
            onChange={type => setFilters(filters => ({ ...filters, type }))}
          />
        )}

        {expenseType && (
          <ExpenseTypeSelect
            loadOnMount={false}
            value={expenseTypeId}
            onChange={expenseTypeId =>
              setFilters(filters => ({ ...filters, expenseTypeId }))
            }
          />
        )}

        {ticketType && (
          <TicketTypeSelectMulti
            loadOnMount={true}
            value={ticketTypeId}
            multiple={true}
            onChange={ticketTypeId =>
              setFilters(filters => ({ ...filters, ticketTypeId }))
            }
          />
        )}

        {product && (
          <ProductSelect
            loadOnMount={true}
            value={productId}
            onChange={productId =>
              setFilters(filters => ({ ...filters, productId }))
            }
          />
        )}

        {props.children}

        {numRows && (
          <NumberSelect
            label='Número de Filas'
            factor={i => i * i * i * 20}
            value={numRows}
            onChange={setNumRows}
          />
        )}

        {wanMac && (
          <SubscriptionMacSearch
            label='WanMac/IP'
            value={subscriptions}
            numRows={numRows}
            onChange={
              subscriptions =>
                setFilters(filters => ({ ...filters, subscriptions }))
            }
          />
        )}
      </Form.Group>
    </Form>
  )
}

Filters.defaultProps = {
  client: false,
  company: false,
  date: false,
  expenseType: false,
  location: false,
  numRows: false,
  paymentType: false,
  user: false,
  creator: false,
  employee: false,
  code: false
}